module.exports = __webpack_public_path__ + "img/footer.8962f4bb.jpg";